export const smartLabelColors = {
  CLIENT: ['#7CD323', '#3C6412', '#559019'],
  AGENCY: ['#4A90E2', '#1A5193', '#2169BF'],
} as const;

// currently used for plan statuses
export const defaultColors = [
  '#007BFF',
  '#0255B0',
  '#F04438',
  '#B42318',
  '#F79009',
  '#B54708',
  '#17B26A',
  '#067647',
  '#667085',
  '#344054',
] as const;
